import React from "react";
import { Link } from "react-router-dom";

const ScrollToTopLink = ({
  istoplevel,
  handleSubmenuItemTouch,
  onClick,
  children,
  ...props
}) => {
  const handleClick = (event) => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    if (typeof onClick === "function") {
      onClick(event);
    }

    if (typeof handleSubmenuItemTouch === "function") {
      handleSubmenuItemTouch(event);
    }
  };

  return (
    <Link {...props} onClick={handleClick}>
      {children}
    </Link>
  );
};

export default ScrollToTopLink;
